import { ASSET_PREFIX } from "utils/constants";
import { Parallax } from "react-parallax";
import { ReactNode } from "react";

interface IHeroImageBackgroundContainerProps {
  id?: string;
  background?: string;
  children?: ReactNode;
  padding?: string;
  nonMoving?: boolean;
  disableParallax?: boolean;
  style?: React.CSSProperties;
}

const HeroImageBackgroundContainer = ({
  id = "heroImageBackgroundContainer",
  background = `${ASSET_PREFIX}/images/hero-new.jpg`,
  children,
  padding = "2em",
  nonMoving = false,
  disableParallax = false,
  style,
}: IHeroImageBackgroundContainerProps) => {
  // Only use parallax scrolling on desktop
  const useParallaxScrollingBackground =
    !disableParallax &&
    typeof window !== "undefined" &&
    !window.matchMedia("(hover: none) and (pointer: coarse)").matches;

  return (
    <Parallax
      bgClassName={`${id}-parallaxImage`}
      bgImage={background}
      strength={useParallaxScrollingBackground ? 500 : 0}
      style={{
        width: "100%",
        margin: 0,
        backgroundPosition: nonMoving ? "top" : "center",
        backgroundSize: nonMoving ? "auto 1500px" : "cover",
        transition: "0.2s",
      }}
    >
      <div
        style={{
          backgroundColor: "rgba(0,0,0,0.5)",
          minHeight: "200px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding,
          ...style,
        }}
      >
        {children}
      </div>

      <style jsx>{`
        :global(.${id}-parallaxImage) {
          width: 100% !important;
          object-fit: cover !important;
        }
      `}</style>
    </Parallax>
  );
};

export default HeroImageBackgroundContainer;
